<template>
<div>
  <b-jumbotron
    header="Ward Notification Pager"
    lead="Using Twilio SMS/Whatsapp to notify contacts via 10 digit A2P">
    <hr class="my-4">
    <p> If you have an account, please log in, otherwise request more info to get started!</p>
  </b-jumbotron>

  <b-card-group columns>
    <b-card
      title="Broadcast an SMS/Whatsapp messages in bulk"
      img-src="@/assets/img/jonas-leupe-wK-elt11pF0-unsplash.jpg"
      img-alt="Image"
      class="rounded-0"
      img-top
      >
      <b-card-text>
      Target specific organizations/groups or create custom organizations/groups and add contacts.
      </b-card-text>
    </b-card>

    <b-card
      bg-variant="secondary"
      text-variant="white"
    >
      <b-card-title>Targeted for Ward Leadership/Administrators</b-card-title>
      <b-card-text>
        The application is mainly for administrators. Allows you to have a closer engagement with contacts and a great way to notify
        of last minute events.
      </b-card-text>
    </b-card>

    <b-card
      title="Schedule Messages and Plan Ahead"
      img-src="@/assets/img/brad-neathery-nPy0X4xew60-unsplash.jpg"
      img-alt="Image"
      class="rounded-0"
      img-top
      >
      <b-card-text>
      Plan ahead and schedule event/activity reminders that will be sent at a specific date/time.
      </b-card-text>
    </b-card>

    <b-card
      title="Birectional Messaging"
      img-src="@/assets/img/brett-jordan-LPZy4da9aRo-unsplash.jpg"
      img-alt="Image"
      class="rounded-0"
      img-top

    >
      <b-card-text>
        Twilio can forward messages that are sent your long code number. So, not only can you
        send bulk messages but also receive them in the application without having to log in
        to the twilio application.

        As a user you have the option to opt in and get notified by email when a new message is
        received by your ward.
      </b-card-text>
    </b-card>

    <b-card
      bg-variant="primary"
      text-variant="white"
    >
      <b-card-title>Multi User Support</b-card-title>
      <b-card-text>
        You can have as many users as you require can be granular as to what each user can and can't do.
      </b-card-text>
    </b-card>

<b-card
      title="SMS Twilio Cost Calculator"
      img-src="@/assets/img/kelly-sikkema-3-Tc_5LROrM-unsplash.jpg"
      img-alt="Image"
      class="rounded-0"
      img-top
>
      <b-card-text>
        Text messages cost $ and as you compose a message to go out you can preview
        and get an estimate of the cost of the message if you were to send it out
        helping in keeping costs to a minimum.
      </b-card-text>
    </b-card>
<b-card
      title="Contact Management"
      img-src="@/assets/img/photo-1600783246032-1056431c253c.jpeg"
      img-alt="Image"
      class="rounded-0"
      img-top >
      <b-card-text>
        Load and verify contacts and then add them to the ward. You can then quickly
        start sending messages to the whole ward.

        Contacts can opt-out from receiving messages. The application automatically will
        identify and flag them as unsubscribed from receiving further messages. These
        contacts must re-subscribe in order to receive messages.
      </b-card-text>
    </b-card>
<b-card
      title="Appointment Management"
      img-src="@/assets/img/eric-rothermel-FoKO4DpXamQ-unsplash.jpg"
      img-alt="Image"
      class="rounded-0"
      img-top >
      <b-card-text>
        Manage appointments interviews with the appointment booking feature.
        Lets you quickly schedule appointments along with reminders to your contacts.
        Schedule when you want reminders to go out through the twilio sms/whatsapp service.

        Your contact will receive a reminder at the scheduled time and will allow them to reply
        if changes occur.
      </b-card-text>
    </b-card>
    <b-card
      bg-variant="success"
      text-variant="white"
    >
      <b-card-title>Free To Use (Almost)</b-card-title>
      <b-card-text>
        The application is free to use! no costs attached. The only cost related to the application is twilio.
        Every ward must have their only twilio account to use the application. A lot of the features are created to reduce
        the twilio cost as much as possible.
      </b-card-text>
    </b-card>

  </b-card-group>
</div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
      items: [
        {
          text: 'Features',
          to: { name: 'features' }
        },
        {
          text: 'FAQ',
          to: { name: 'about' }
        },
        {
          text: 'Request Demo',
          to: { name: 'contact' }
        },
        {
          text: 'Log In',
          to: { name: 'login' },
        }
      ]
    }
  }
}
</script>
